import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasCartama() {
  return (
    <CityPagePersianas
      name="Cártama"
      slug="cartama"
      cp="29570"
      poblacion={26000}
      zonaGeo="Guadalhorce"
      lat={36.7079}
      lng={-4.6321}
      zonas={[
        "Cártama Pueblo",
        "Cártama Estación",
        "Doña Ana",
      ]}
      landmarks={[
        "Castillo de Cártama",
        "Iglesia San Pedro",
        "Río Guadalhorce",
      ]}
      municipiosLimitrofes={[
        "Málaga",
        "Almogía",
        "Pizarra",
        "Coín",
        "Alhaurín de la Torre",
      ]}
      festivalLocal="Feria de la Virgen de los Remedios, finales de abril"
      contextoTipologico="Municipio con fuerte crecimiento por proximidad Málaga, urbanizaciones nuevas residenciales."
      isCoreZone={false}
    />
  );
}